import React from 'react'

import { Page } from '../../../components/layouts/page'
import { Column } from '../../../components/layouts/columns'
// import { Button } from '../../../components/ui/button'
import { Icon } from '../../../components/icons'
import { Table } from '../../../components/ui/table'
import { Input } from '../../../components/ui/input'
import { useBillingClients } from './_hooks/useBillingClients'
import { Button } from '../../../components/ui/button'
import { sumDaysInDate, SumHoursInDateTime } from '../../../utils/dates'
import { translateStatusInvoice } from './_utils'
import { ModalHistoryBilling } from './_modal/modalHistoryBilling'

export const AdminClientsBilling = () => {
  const {
    loading,
    search,
    setSearch,
    dataFiltered,
    FetchGetData,
    HandleCancelBilling,
    HandleSetHistoryBilling,
    modalHistory,
    setModalHistory,
    dataContext,
    HandleCreateBilling,
    formContext,
  } = useBillingClients()

  return (
    <Page.Section className="is-fullheight-with-navbar  mt-6 pt-6">
      <ModalHistoryBilling
        active={modalHistory}
        setActive={setModalHistory}
        loading={loading}
        dataContext={dataContext}
      ></ModalHistoryBilling>
      <Column.Root>
        <Column.Content>
          <p className="subtitle is-size-3">Faturamento</p>
        </Column.Content>
        <Column.Content>
          <Button.Root align="right">
            <Button.Content>
              <Button.Bt
                color="is-light"
                type="button"
                className="mx-1"
                size={'is-small'}
                loading={loading}
                action={() => {
                  HandleCreateBilling()
                }}
              >
                <Icon size={20}>bill</Icon>
              </Button.Bt>
              <p className="is-size-7 has-text-grey has-text-centered">Faturar</p>
            </Button.Content>
            <Button.Content>
              <Button.Bt
                color="is-dark"
                colorText="has-text-white"
                action={() => {
                  FetchGetData()
                }}
                loading={loading}
              >
                <Icon size={15}>sync</Icon>
              </Button.Bt>
            </Button.Content>
          </Button.Root>
          <p className="has-text-right has-text-grey">
            Próximo Faturamento: {formContext?.lastInvoiceDate ? sumDaysInDate(formContext?.lastInvoiceDate, 1) : '-'}
          </p>
        </Column.Content>
      </Column.Root>

      {/* Barra de pesquisa */}
      <Column.Root className="is-mobile">
        <Column.Content>
          <Input.Root>
            <Input.Contents alignIcon={'left'}>
              <Input.Prompt value={search} setValue={setSearch} placeholder="Pesquisar..."></Input.Prompt>
              <Input.Icon align="is-left">
                <Icon size={20}>search</Icon>
              </Input.Icon>
            </Input.Contents>
          </Input.Root>
        </Column.Content>
      </Column.Root>
      {/* Tabela de dados */}
      <Column.Root className="is-mobile">
        <Column.Content>
          <Table.Root className="is-fullwidth is-hoverable is-narrow has-text-centered">
            <Table.Head>
              <Table.Row key={'table_payments_head'}>
                <Table.Cell>Nº Doc</Table.Cell>
                <Table.Cell>Descrição</Table.Cell>
                <Table.Cell>Faturado em</Table.Cell>
                <Table.Cell>Valor</Table.Cell>
                <Table.Cell>Situação</Table.Cell>
                <Table.Cell>Ações</Table.Cell>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {dataFiltered.map((value) => {
                return (
                  <>
                    <Table.Row
                      key={value.id}
                      onclick={async () => {
                        await HandleSetHistoryBilling(value)
                      }}
                    >
                      <Table.Cell className="is-size-7 is-vcentered">{Number(value.cNumOS)}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">{value.descricao}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">
                        {SumHoursInDateTime(value.dt_created, -3)}
                      </Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">R$ {value.valueOS}</Table.Cell>
                      <Table.Cell className="is-size-7 is-vcentered">
                        <p className={`tag ${translateStatusInvoice(value.status)[1]}`}>
                          {translateStatusInvoice(value.status)[0]}
                        </p>
                      </Table.Cell>
                      <Table.Cell className="is-vcentered" style={{ height: 50 }}>
                        <div style={{ marginBottom: -5, marginTop: 5 }}>
                          <Button.Root align="centered">
                            {(value?.cUrlNfse || value?.cUrlPdfDemo) && (
                              <Button.Content>
                                <Button.A
                                  className={'mx-2'}
                                  color="is-warning"
                                  link={value.cUrlNfse !== '' ? value.cUrlNfse : value.cUrlPdfDemo}
                                  loading={loading}
                                >
                                  <Icon size={15}>print</Icon>
                                </Button.A>
                              </Button.Content>
                            )}
                            {value?.status === 'successBilling' && (
                              <Button.Content>
                                <Button.Bt
                                  className={'mx-2'}
                                  color="is-danger"
                                  loading={loading}
                                  title="Cancelar Faturamento"
                                  action={async () => {
                                    await HandleCancelBilling(value)
                                  }}
                                >
                                  <Icon size={15}>trash</Icon>
                                </Button.Bt>
                              </Button.Content>
                            )}
                          </Button.Root>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </>
                )
              })}
            </Table.Body>
          </Table.Root>
        </Column.Content>
      </Column.Root>
    </Page.Section>
  )
}
